var _path, _path2, _path3, _path4, _path5, _path6, _path7;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgZipPay(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 103,
    height: 24,
    viewBox: "0 0 103 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M97.6256 20.0003H92.9326L92.2737 14.6341L85.632 6.5H90.762L94.2503 10.9248L96.785 6.5H101.896L96.969 14.6529L97.6256 20.0003Z",
    fill: "#AA8FFF"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M82.4388 14.4835L80.2836 10.5482L79.1138 14.4835H82.4388ZM85.4532 20.0003L84.1809 17.6844H78.1769L77.4922 20.0003H72.6852L77.2026 6.5H82.4276L90.2222 20.0003H85.4532Z",
    fill: "#AA8FFF"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M72.5383 11.3604C72.1641 8.32588 69.7802 6.48694 66.5408 6.50007H55.75L57.4073 20H62.2589L61.927 17.301H67.0638C71.11 17.2996 72.9599 14.7801 72.5383 11.3604ZM66.5422 13.5152L61.4645 13.5203L61.067 10.2801L66.1731 10.2845C67.3731 10.299 67.9873 10.9745 68.0865 11.8995C68.1477 12.4954 67.8757 13.5152 66.5422 13.5152Z",
    fill: "#AA8FFF"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M18.0938 6.50012L19.7511 20H35.974L34.316 6.50012H18.0938Z",
    fill: "#AA8FFF"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M52.9858 11.3603C52.6116 8.32583 50.2277 6.48689 46.9883 6.50002H36.1946L37.8526 19.9999H42.7064L42.3745 17.301H47.512C51.5575 17.2995 53.4096 14.78 52.9858 11.3603ZM46.9897 13.5151L41.9127 13.5202L41.5145 10.28L46.6206 10.2844C47.8205 10.299 48.4347 10.9745 48.534 11.8994C48.5952 12.4954 48.3231 13.5151 46.9904 13.5151H46.9897Z",
    fill: "#1A0826"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M23.0516 4.76525C23.9117 3.85031 23.7697 2.31966 22.7344 1.34644C21.6991 0.373228 20.1626 0.325996 19.3025 1.24093C18.4424 2.15586 18.5845 3.6865 19.6198 4.65972C20.655 5.63293 22.1915 5.68018 23.0516 4.76525Z",
    fill: "#1A0826"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M1.19411 16.228L1.65731 20H17.8678L17.3375 15.6802H9.77899L9.71334 15.144L16.6745 10.2801L16.2098 6.50005H-2.45582e-08L0.530309 10.8198H8.10126L8.16764 11.3596L1.19411 16.228Z",
    fill: "#1A0826"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgZipPay);
export default __webpack_public_path__ + "static/media/zip-pay.7891842cb32b658c2e4a09a2e2a619f0.svg";
export { ForwardRef as ReactComponent };